import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Provider } from '@models/provider.model';
import { SCHEDULE_STATUS } from '@models/report-template.model';
import * as fromReporting from '@store/reducers/reporting/reporting.reducer';
import { selectUserOrgId } from '@store/selectors/user/user.selectors';
import { selectProgramYear } from '@store/selectors/dashboard/dashboard.selectors';
import { selectProviders as selectClinicianProviders } from '@store/selectors/clinician-details/clinician-details.selectors';

export const selectReportingState = createFeatureSelector<fromReporting.State>(
  fromReporting.reportingFeatureKey
);

export const selectReportTemplates = createSelector(
  selectReportingState,
  (state) => state.templates
);

export const selectIsRunning = createSelector(
  selectReportingState,
  (state) => state.isRunning
);

export const selectIsBulkRunning = createSelector(
  selectReportingState,
  (state) => state.isBulkRunning
);

export const selectIsViewingTemplate = createSelector(
  selectReportingState,
  (state) => state.isViewingTemplate
);

export const selectIsExportingAudit = createSelector(
  selectReportingState,
  (state) => state.isExportingAudit
);

// Organizational Reports
export const selectReportResults = createSelector(
  selectReportingState,
  (state) => state.reportResults
);

export const selectIsLoadingResults = createSelector(
  selectReportingState,
  (state) => state.isLoadingResults
);

// Scheduled Reports
export const selectSchedules = createSelector(
  selectReportingState,
  (state) => state.schedules
);

export const selectIsLoadingSchedules = createSelector(
  selectReportingState,
  (state) => state.isLoadingSchedules
);

export const selectIsSavingSchedule = createSelector(
  selectReportingState,
  (state) => state.isSavingSchedule
);

export const selectScheduleDuplicateError = createSelector(
  selectReportingState,
  (state) => state.scheduleDuplicateError
);

export const selectIsReactivatingSchedule = createSelector(
  selectReportingState,
  (state) => state.isReactivatingSchedule
);

export const selectShowInactiveSchedules = createSelector(
  selectReportingState,
  (state) => state.showInactiveSchedules
);

export const selectFilteredSchedules = createSelector(
  selectSchedules,
  selectShowInactiveSchedules,
  (schedules, showInactive) =>
    showInactive ? schedules : schedules.filter((s) => s.statusId === SCHEDULE_STATUS.ACTIVE)
);

export interface ReportContext {
  orgId: number;
  programYear: number;
  providers: Provider[];
}

export const selectReportContext = createSelector(
  selectProgramYear,
  selectUserOrgId,
  selectClinicianProviders,
  (programYear, orgId, providers): ReportContext => ({ programYear, orgId, providers })
);

